<h3>Edit User</h3>
<user-edit-form [model]="model | async" (onSave)="saveUser($event)" (onCancel)="cancel()"></user-edit-form>
